import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { keyframes, css } from "@emotion/react";

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const ToolUseContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.text.disabled};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  ${(props) =>
    props.isExecuting
      ? css`
          background: linear-gradient(
            90deg,
            #607d8b 0%,
            #ffffff 25%,
            #9e9e9e 50%,
            #757575 75%,
            #607d8b 100%
          );
          background-size: 300% 100%;
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: ${gradientAnimation} 3s linear infinite;
        `
      : css`
          color: ${(p) => p.theme.text.disabled};
        `}
`;

const ToolUseBlock = ({ toolName, stepIndex, currentStepIndex }) => {
  const [isExecuting, setIsExecuting] = useState(false);

  // Determine if this specific tool block should be actively executing
  const shouldBeExecuting = currentStepIndex === stepIndex;

  // Track when tool execution starts and stops for this specific block
  useEffect(() => {
    if (shouldBeExecuting && !isExecuting) {
      // This tool just started executing
      setIsExecuting(true);
    } else if (!shouldBeExecuting && isExecuting) {
      // This tool just finished executing
      setIsExecuting(false);
    }
  }, [shouldBeExecuting, isExecuting, stepIndex]);

  if (!toolName) return null;

  return (
    <ToolUseContainer isExecuting={isExecuting}>
      <span className="tool-icon">🛠️</span>
      <span>{toolName}</span>
    </ToolUseContainer>
  );
};

export default ToolUseBlock;
